import { createSelector } from '@reduxjs/toolkit';
import { selectSearchMetaData } from './selectSearchMetaData';
import { numberToPrettyString, plural } from '@cian/utils';
import { selectIsInlineFiltersRedesigned } from '../redesigned/selectIsInlineFiltersRedesigned';
import { selectPageType } from '../page/selectPageType';
import { selectDealType } from '../jsonQuery/selectDealType';
import { EPageType } from 'shared/types/page';
import { FDealType } from '../../../packages/JsonQuery';

export const selectSearchResultsText = createSelector(
  selectSearchMetaData,
  selectIsInlineFiltersRedesigned,
  selectPageType,
  selectDealType,
  (searchMeta, isFiltersRedesign, pageType, dealType) => {
    const offersCount = searchMeta?.count;

    if (isFiltersRedesign && pageType === EPageType.MAIN) {
      return 'Применить';
    }

    if (dealType === FDealType.RentDaily) {
      return 'Показать объекты';
    }

    if (typeof offersCount === 'undefined') {
      return 'Показать объекты';
    }

    return `Показать ${numberToPrettyString(offersCount)} ${plural(offersCount, ['объект', 'объекта', 'объектов'])}`;
  },
);
